import { Card } from "@mui/material";
import {
  COLOR_BLACK,
  COLOR_LIGHT_GRAY,
  COLOR_VERY_LIGHT_GRAY,
} from "../../data/colors/Colors";

interface props {
  children: React.ReactElement;
  padding?: number;
  borderRadius?: number;
  background?: string;
  height?: number | string;
  minHeight?: number | string;
  maxHeight?: number | string;
  width?: number | string;
  border?: string;
}

export function CustomCardView(props: props) {
  return (
    <Card
      elevation={0}
      sx={{
        background: props.background ?? "transparent",
        p: props.padding ?? 4,
        borderRadius: props.borderRadius ?? 8,
        height: props.height,
        minHeight: props.minHeight,
        maxHeight: props.maxHeight,
        width: props.width,
        border: props.border ?? "1px solid " + COLOR_LIGHT_GRAY,
      }}
    >
      {props.children}
    </Card>
  );
}
